type Props = {
  eyebrow?: string;
  title: string;
  body?: string;
  center?: boolean;
};

export function SectionHeading({ eyebrow, title, body, center }: Props) {
  return (
    <div className={center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-copper">{eyebrow}</p>
      )}
      <span className={`copper-rule mt-4 ${center ? "mx-auto" : ""}`} />
      <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl text-silver-light text-balance">{title}</h2>
      {body && <p className="mt-4 text-base md:text-lg text-silver">{body}</p>}
    </div>
  );
}
